import { useQuery } from '@tanstack/react-query';

import { getMailchimpStatus } from '../api/status';
import type { MailchimpStatusResponse } from '../types';

export function useMailchimpStatus(orgId: number | string | undefined) {
  return useQuery<MailchimpStatusResponse>({
    queryKey: ['mailchimpStatus', orgId],
    queryFn: () => {
      if (!orgId) {
        throw new Error('orgId is required');
      }
      return getMailchimpStatus(orgId);
    },
    enabled: !!orgId,
    refetchInterval: query => {
      const { data } = query.state;
      if (!data?.connected) {
        return false;
      }
      if (data?.bulk_completed_at == null) {
        return 5000;
      }
      return 30000;
    },
  });
}
